import { type SVGProps } from "react";

export const Search = (props: SVGProps<SVGSVGElement>) => {
  return (
    // <svg
    //   width="100%"
    //   preserveAspectRatio="xMidYMid meet"
    //   viewBox="0 0 20 20"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    //   className={className ?? ""}
    //   {...rest}
    // >
    //   <path
    //     d="M19.6334 17.871L15.7624 13.9984C18.6588 10.1278 17.8691 4.64195 13.9984 1.74551C10.1278 -1.15092 4.64195 -0.361157 1.74551 3.50949C-1.15092 7.38013 -0.361157 12.866 3.50949 15.7624C6.61871 18.0891 10.8892 18.0891 13.9984 15.7624L17.871 19.635C18.3577 20.1217 19.1467 20.1217 19.6333 19.635C20.12 19.1483 20.12 18.3593 19.6333 17.8727L19.6334 17.871ZM8.78623 15.015C5.34618 15.015 2.55751 12.2263 2.55751 8.78623C2.55751 5.34618 5.34618 2.55751 8.78623 2.55751C12.2263 2.55751 15.015 5.34618 15.015 8.78623C15.0113 12.2247 12.2248 15.0113 8.78623 15.015Z"
    //     fill={fill ?? "#353B3F"}
    //   />
    // </svg>
    <svg
      preserveAspectRatio="xMidYMid meet"
      width="20px" height="20px" viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <g
        transform="translate(1 1)"
        stroke="#000"
        strokeWidth="15"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path fill="#FDCC00" d="M296.387,273.773c-6.827,8.533-15.36,17.067-23.893,23.893l73.387,73.387l23.893-23.893
		L296.387,273.773z"/>
        <path fill="#FFE100" d="M332.227,171.373c0,89.6-72.533,162.133-162.133,162.133S7.96,260.973,7.96,171.373
		S80.493,9.24,170.093,9.24C259.693,9.24,332.227,82.627,332.227,171.373"/>
        <path fill="#FFA800" d="M170.093,9.24c-4.267,0-8.533,0-12.8,0.853c83.627,6.827,149.333,76.8,149.333,161.28
		S240.92,326.68,157.293,332.653c4.267,0,8.533,0.853,12.8,0.853c89.6,0,162.133-72.533,162.133-162.133
		C332.227,82.627,259.693,9.24,170.093,9.24"/>
        <path fill="#FFFFFF" d="M33.56,171.373c0-85.333,65.707-155.307,149.333-161.28c-4.267,0-8.533-0.853-12.8-0.853
		C80.493,9.24,7.96,81.773,7.96,171.373s72.533,162.133,162.133,162.133c4.267,0,8.533,0,12.8-0.853
		C99.267,326.68,33.56,256.707,33.56,171.373"/>
        <path fill="#00DA6C" d="M489.24,492.227L489.24,492.227c-13.653,13.653-34.987,13.653-48.64,0L333.933,383.853l48.64-48.64
		l107.52,109.227C502.893,457.24,502.893,479.427,489.24,492.227"/>
        <path fill="#00AD55" d="M492.653,442.733l-107.52-109.227L374.04,344.6l96.427,98.133c13.653,13.653,13.653,34.987,0,48.64
		c-3.413,3.413-8.533,5.973-12.8,7.68c11.947,4.267,25.6,1.707,34.987-7.68C506.307,477.72,506.307,456.387,492.653,442.733"/>
        <path d="M170.093,340.333c-93.867,0-170.667-76.8-170.667-170.667S76.227-1,170.093-1S340.76,75.8,340.76,169.667
		S263.96,340.333,170.093,340.333z M170.093,16.067c-84.48,0-153.6,69.12-153.6,153.6s69.12,153.6,153.6,153.6
		s153.6-69.12,153.6-153.6S254.573,16.067,170.093,16.067z"/>
        <path d="M465.347,509.293c-11.093,0-22.187-4.267-29.867-12.8l-113.493-115.2l60.587-60.587l113.493,115.2
		c7.68,7.68,12.8,18.773,12.8,29.867c0,11.093-4.267,22.187-12.8,29.867C487.533,503.32,476.44,509.293,465.347,509.293z
		 M345.88,381.293l101.547,102.4c9.387,9.387,26.453,9.387,35.84,0c5.12-5.12,7.68-11.093,7.68-17.92s-2.56-13.653-7.68-17.92
		l-101.547-102.4L345.88,381.293z"/>
        <path d="M345.88,381.293l-87.04-86.187l7.68-5.973c8.533-6.827,16.213-14.507,23.04-23.04l5.973-7.68L381.72,344.6L345.88,381.293z
		 M284.44,295.96l61.44,61.44l11.947-11.947l-61.44-61.44C292.973,288.28,288.707,292.547,284.44,295.96z"/>
        <path d="M170.093,178.2c-5.12,0-8.533-3.413-8.533-8.533v-51.2c0-5.12,3.413-8.533,8.533-8.533c5.12,0,8.533,3.413,8.533,8.533
		v51.2C178.627,174.787,175.213,178.2,170.093,178.2z"/>
        <path d="M204.227,212.333c-2.56,0-4.267-0.853-5.973-2.56L164.12,175.64c-3.413-3.413-3.413-8.533,0-11.947
		c3.413-3.413,8.533-3.413,11.947,0l34.133,34.133c3.413,3.413,3.413,8.533,0,11.947
		C208.493,211.48,206.787,212.333,204.227,212.333z"/>
        <path d="M170.093,340.333c-5.12,0-8.533-3.413-8.533-8.533v-34.133c0-5.12,3.413-8.533,8.533-8.533c5.12,0,8.533,3.413,8.533,8.533
		V331.8C178.627,336.92,175.213,340.333,170.093,340.333z"/>
        <path d="M170.093,50.2c-5.12,0-8.533-3.413-8.533-8.533V7.533c0-5.12,3.413-8.533,8.533-8.533c5.12,0,8.533,3.413,8.533,8.533
		v34.133C178.627,46.787,175.213,50.2,170.093,50.2z"/>
        <path d="M42.093,178.2H7.96c-5.12,0-8.533-3.413-8.533-8.533c0-5.12,3.413-8.533,8.533-8.533h34.133
		c5.12,0,8.533,3.413,8.533,8.533C50.627,174.787,47.213,178.2,42.093,178.2z"/>
        <path d="M332.227,178.2h-34.133c-5.12,0-8.533-3.413-8.533-8.533c0-5.12,3.413-8.533,8.533-8.533h34.133
		c5.12,0,8.533,3.413,8.533,8.533C340.76,174.787,337.347,178.2,332.227,178.2z"/>
        <path d="M284.44,292.547c-2.56,0-4.267-0.853-5.973-2.56l-20.48-20.48c-3.413-3.413-3.413-8.533,0-11.947
		c3.413-3.413,8.533-3.413,11.947,0l20.48,20.48c3.413,3.413,3.413,8.533,0,11.947C288.707,291.693,287,292.547,284.44,292.547z"/>
        <path d="M76.227,84.333c-2.56,0-4.267-0.853-5.973-2.56l-20.48-20.48c-3.413-3.413-3.413-8.533,0-11.947
		c3.413-3.413,8.533-3.413,11.947,0l20.48,20.48c3.413,3.413,3.413,8.533,0,11.947C80.493,83.48,78.787,84.333,76.227,84.333z"/>
        <path d="M55.747,292.547c-2.56,0-4.267-0.853-5.973-2.56c-3.413-3.413-3.413-8.533,0-11.947l20.48-20.48
		c3.413-3.413,8.533-3.413,11.947,0c3.413,3.413,3.413,8.533,0,11.947l-20.48,20.48C60.013,291.693,57.453,292.547,55.747,292.547z"
        />
        <path d="M263.96,84.333c-2.56,0-4.267-0.853-5.973-2.56c-3.413-3.413-3.413-8.533,0-11.947l20.48-20.48
		c3.413-3.413,8.533-3.413,11.947,0c3.413,3.413,3.413,8.533,0,11.947l-20.48,20.48C268.227,83.48,266.52,84.333,263.96,84.333z"/>
      </g>
    </svg>

  );
};
